export var DividerData_LineStyle;
(function (DividerData_LineStyle) {
    /** SINGLE - Single Line */
    DividerData_LineStyle["SINGLE"] = "SINGLE";
    /** DOUBLE - Double Line */
    DividerData_LineStyle["DOUBLE"] = "DOUBLE";
    /** DASHED - Dashed Line */
    DividerData_LineStyle["DASHED"] = "DASHED";
    /** DOTTED - Dotted Line */
    DividerData_LineStyle["DOTTED"] = "DOTTED";
    DividerData_LineStyle["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividerData_LineStyle || (DividerData_LineStyle = {}));
export var DividerData_Width;
(function (DividerData_Width) {
    /** LARGE - Large line */
    DividerData_Width["LARGE"] = "LARGE";
    /** MEDIUM - Medium line */
    DividerData_Width["MEDIUM"] = "MEDIUM";
    /** SMALL - Small line */
    DividerData_Width["SMALL"] = "SMALL";
    DividerData_Width["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividerData_Width || (DividerData_Width = {}));
export var DividerData_Alignment;
(function (DividerData_Alignment) {
    /** CENTER - Center alignment */
    DividerData_Alignment["CENTER"] = "CENTER";
    /** LEFT - Left alignment */
    DividerData_Alignment["LEFT"] = "LEFT";
    /** RIGHT - Right alignment */
    DividerData_Alignment["RIGHT"] = "RIGHT";
    DividerData_Alignment["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividerData_Alignment || (DividerData_Alignment = {}));
//# sourceMappingURL=plugin_divider.enums.js.map